import api from 'connections/api';
import routes_api from 'connections/routes_api';

// ##### PLUGGY SERVICES
export const getPluggyApiToken = async () => {
  const response = await api.get(routes_api.finance_extras_pluggytoken);
  return response.data.api_token;
};

export const getPluggyCredentials = async () => {
  const response = await api.get(routes_api.finance_extras_pluggycredentials);
  return response.data;
};

export const getPluggyItems = async () => {
  const response = await api.get(routes_api.finance_extras_pluggyitems);
  return response.data.items;
};

/** Cached Pluggy accounts from DB (GET). Use syncPluggyAccounts to refresh from Pluggy API. */
export const getPluggyAccounts = async (itemId) => {
  const response = await api.get(routes_api.finance_extras_pluggyaccounts, {
    params: { item_id: itemId }
  });
  return response.data.accounts;
};

/**
 * Sync accounts from Pluggy API into server cache (uses Pluggy quota).
 * @param {{ item_id?: string, sync_all?: boolean }} payload
 */
export const syncPluggyAccounts = async (payload) => {
  const response = await api.post(routes_api.finance_extras_pluggyaccounts, payload);
  return response.data;
};

export const getPluggyTransactions = async ({ account_id, page_size, from_date, to_date }) => {
  const response = await api.get(routes_api.finance_extras_pluggytransactions, {
    params: {
      account_id,
      page_size,
      from: from_date,
      to: to_date,
    }
  });
  return response.data.transactions;
};
